import { DefaultThreatAssessment, ThreatAssessment } from "./ThreatAssessment";

export type ExistingImpactsState = ThreatAssessment;

export const DefaultExistingImpacts: ExistingImpactsState =
    DefaultThreatAssessment;
